/* eslint-disable @typescript-eslint/default-param-last */
import { ActionType } from '../../types/Interviews/hiringRoles.types';
import { GET_HIRING_ROLES } from '../../constants/ActionTypes';
import initialState from '../../store/initialState';

/**
 * Description
 * @param {any} state=initialState.jobRoles
 * @param {any} action:ActionType
 * @returns {any}
 */
const hiringRolesReducer = (
  state = initialState.hiringRoles,
  action: ActionType
) => {
  switch (action?.type) {
    case `${GET_HIRING_ROLES}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default hiringRolesReducer;
